(function(){
    'use strict';

    var openAuthBtn = $('.open-auth');   
    
    openAuthBtn.on('click', function(event) {
        // $.colorbox({href:"/login.html"});
        $.colorbox({inline:true, href:"#login"});
    });

})();